import { render, staticRenderFns } from "./VideoHeaderTitle.vue?vue&type=template&id=d79735b8&"
import script from "./VideoHeaderTitle.vue?vue&type=script&lang=js&"
export * from "./VideoHeaderTitle.vue?vue&type=script&lang=js&"
import style0 from "./VideoHeaderTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports